import Styleguide from "@store/Framework/Types/Styleguide";

const colors: Styleguide["colors"] = {
    primary: {
        main: "#00305e",
        contrast: "#ffffff",
        light: "#557BA5",
        dark: "#00305e",
    },
    secondary: {
        main: "#B81237",
        contrast: "#ffffff",
        light: "#E61F4C",
        dark: "#4c5258",
    },
    tertiary: {
        contrast: "#ffffff",
        light: "#90989f",
        dark: "#4c5258",
    },
    common: {
        border: "#D8D8D8",
        borderLight: "#D8D8D8",
        borderDark: "#ADADAC",
        accent: "#F9F9F9",
        accentContrast: "#363636",
        accentContrastLight: "#EBEBEB",
        background: "#FFFFFF",
        backgroundContrast: "#363636",
        disabled: "#F9F9F9",
        disabledDark: "#F2F2F2",
    },
    text: {
        main: "#101e25",
        accent: "#2D3435",
        disabled: "#475353",
        link: "#6050A1",
        linkHover: "#1b3f76",
        linkAlt: "#0F0F0F",
        linkAltHover: "#275AA8",
        input: "#101e25",
    },
    success: {
        main: "#028526",
        contrast: "#ffffff",
        light: "#f2faf6",
    },
    warning: {
        main: "#AF5C18",
        contrast: "#ffffff",
        light: "#fbf9f3",
    },
    danger: {
        main: "#DF1642",
        contrast: "#ffffff",
        light: "#f3eced",
    },
    info: {
        main: "#1E63FF",
        contrast: "#ffffff",
        light: "#f4fafc",
    },
    neutral: {
        main: "#D0CFCF",
        contrast: "#ffffff",
        light: "#F9F9F9",
    },
    invert: {
        main: "#ffffff",
        contrast: "#0f0f0f",
        dark: "#ececec",
    },
    placeholder: {
        main: "#666666",
        disabled: "#475353",
    },
    button: {
        disabled: {
            main: "#CCCCCC",
            contrast: "#475353",
        },
    },
    header: {
        main: "#FFFFFF",
        contrast: "#101e25",
        hover: "#101e25",
        accent: "#00305e",
        accentHover: "#00305e",
        accentContrast: "#ffffff",
    },
    menu: {
        mainNavigation: {
            main: "#FFFFFF",
            contrast: "#00305e",
            hover: "#00305e",
            accent: "#00305e",
            accentContrast: "#ffffff",
            accentHover: "#00305e",
            border: "#CCCCCC",
        },
        secondaryNavigation: {
            main: "#00305e",
            contrast: "#ffffff",
            hover: "#ffffff",
        },
        megaMenuWithTabs: {
            tabsBackground: "#f4f4f4",
            tabsBackgroundHover: "#ffffff",
        },
    },
    footer: {
        main: "#F9F9F9",
        contrast: "#00305e",
        alt: "#00305e",
        altContrast: "#ffffff",
    },
    swatch: {
        main: "#CCCCCC",
        contrast: "#0F0F0F",
        hover: "#275AA8",
        selected: "#275AA8",
        selectedHover: "#1b3f76",
    },
};

export default colors;
